module.exports = __webpack_public_path__ + "static/media/GraphImage.7d437e9e.png";